"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

function Alert(_a) {
  var children = _a.children,
      props = tslib_1.__rest(_a, ["children"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8555 0.699219C5.33262 0.699219 0.855469 5.17637 0.855469 10.6992C0.855469 16.2221 5.33262 20.6992 10.8555 20.6992C16.3783 20.6992 20.8555 16.2221 20.8555 10.6992C20.8555 8.04705 19.8019 5.50351 17.9265 3.62815C16.0512 1.75279 13.5076 0.699219 10.8555 0.699219ZM11.8555 14.1992C11.8555 14.4754 11.6316 14.6992 11.3555 14.6992H10.3555C10.0793 14.6992 9.85547 14.4754 9.85547 14.1992V13.1992C9.85547 12.9231 10.0793 12.6992 10.3555 12.6992H11.3555C11.6316 12.6992 11.8555 12.9231 11.8555 13.1992V14.1992ZM11.3855 10.6992C11.5126 10.7001 11.6202 10.6055 11.6355 10.4792L12.0355 7.25922C12.0527 7.11656 12.0078 6.97338 11.9121 6.8662C11.8163 6.75901 11.6792 6.69818 11.5355 6.69922H10.1755C10.0318 6.69818 9.89459 6.75901 9.79889 6.8662C9.70318 6.97338 9.65822 7.11656 9.67547 7.25922L10.0755 10.4792C10.0907 10.6055 10.1983 10.7001 10.3255 10.6992H11.3855Z",
    fill: "currentColor"
  }));
}

exports.Alert = Alert;